import React from 'react';
import {
    List,
    ListItemText,
    Divider,
    Typography,
    Container,
    Box,
    Button,
    Dialog,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { InfoListItem } from '@brightlayer-ui/react-components/core';
import makeStyles from '@mui/styles/makeStyles';
import { Device } from '../../api/types';
import {  Status } from '../../types';
import { StatusTag } from '../StatusTag/StatusTag';

const useStyles = makeStyles(() => ({
    root: {
        width: '350px',
    },
    TypoHeader: {
        margin: '8px 8px 8px 0px',
    },
    Typobody: {
        fontSize: '16px',
        lineHeight: '24px'
    },
    Container: {
        margin: '10px',
        padding: '10px',
        height: '100%',
        overflowX: 'hidden',
    },
}));

const StyledDialog = withStyles({
    root: {
        '& .MuiDialog-paper': {
            width: '450px',
            overflowX: 'hidden',
            height: '60%',
        },
    },
})(Dialog);



export const DeleteModal: React.FC<{
    open: boolean;
    onClose: Function;
    data: any;
    handleContinue: Function;
    name: string;
}> = (props) => {
    const { onClose, open, data, name, handleContinue } = props;
    const classes = useStyles();
  
    const handleClose = (): void => {
        onClose();
    };

    const onContinue = (): void => {
        handleContinue();
    }


    return (
        <StyledDialog onClose={(event: any,reason: string): void => {
            if (reason !== 'backdropClick') {
                handleClose();
            }
        }} aria-labelledby="simple-dialog-title" open={open}>
               
         <Container className={classes.Container}>
            <Box>
                    <Typography variant="h6" className={classes.TypoHeader}>
                        Alert!
                    </Typography>
                    <Typography variant="body1" className={classes.Typobody}>
                        Selecting &apos;continue&apos; will permanently delete this &nbsp;{name} and the 
                        following child device(s)
                    </Typography>
             </Box>
             { data.length > 0 &&         
             <List data-testid="device-item">
                { data.map(
                ( device: Device,index: number) => ( 
                                  <InfoListItem
                                       key={index}
                                        dense
                                        title=""
                                        hidePadding
                                        style = {{ margin: '15px 0px 10px 0px', paddingLeft: '0px', borderBottomStyle: 'inset', borderBottomWidth:'thin' }}
                                        rightComponent={              
                                            <div style={{textOverflow: 'ellipsis', width:"57px", overflow: 'hidden', whiteSpace: 'nowrap'}}>
                                            <StatusTag status={(device.status ? Status.Online : Status.Offline) || Status.Active} style={{ marginRight: 5 }} />
                                            </div>
                                            }
                                        leftComponent={
                                            <ListItemText data-testid="list-item-text" primary={device.name}  primaryTypographyProps={{
                                                style: { fontWeight: 'bold' },
                                            }} secondary={`${device.vendor} ${device.model}|${device.family}`} />
                                        }
                                    />   
                               )
                         )}
                  </List>
            }
                  
            </Container>
            <Divider />
            <Box>
                <Button
                    style={{ margin: 12 }}
                    variant="outlined"
                    color="primary"
                    data-testid="cancel-device"
                    onClick={handleClose} 
                >
                    Cancel
                </Button>
                <Button
                    style={{ float: 'right', margin: 12 }}
                    variant="contained"
                    color="primary"
                    data-testid="add-device-button"
                    onClick={onContinue} 
                >
                    Continue
                </Button>
            </Box>
        </StyledDialog>
        
    );
};
